import React from 'react';
import { DragSource } from 'react-dnd';
import { Button } from '../_atoms';

const pictSource = {
  beginDrag(props) {
    props.saveCurrentPictOrder(props.item);
    return {};
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

export default DragSource(
  'PICTURE',
  pictSource,
  collect
)(({ connectDragSource, isDragging, nameMass, addPhoto, deletePhoto, item }) =>
  connectDragSource(
    <div className="show-image-wrapper">
      <Button
        className="close-image"
        onClick={() => {
          deletePhoto(item.file_id, nameMass);
        }}
      />
      <div
        role="none"
        className="show-image"
        title={item.name}
        style={{
          backgroundImage: `url(${item.url})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          transform: `rotate(${item.rotateAngle || 0}deg)`,
        }}
      />
    </div>
  )
);
